export const spotifyApiConfig = {
  BASE_URL: 'https://api.spotify.com/v1/',
  PATHS: {
    albums: 'albums',
    artists: 'artists',
    tracks: 'tracks',
    new_albums: 'browse/new-releases',
    me: 'me',
    topTracks: 'me/top/tracks',
    topArtists: 'me/top/artists',
    myArtists: 'me/following',
    myAlbums: 'me/albums',
    myPlaylists: 'me/playlists',
    library: 'me/library',
    libraryContains: 'me/library/contains',
    playlists: 'playlists',
    featuredPlaylists: 'browse/featured-playlists',
    search: 'search',
    playerPlay: 'me/player/play',
    playerPause: 'me/player/pause',
    playerPrevious: 'me/player/previous',
    playerNext: 'me/player/next',
    playerSeek: 'me/player/seek',
    playerShuffle: 'me/player/shuffle',
    playerRepeat: 'me/player/repeat',
    playerVolume: 'me/player/volume',
  },
};

export const spotifyTokenApiConfig = {
  BASE_URL: 'https://accounts.spotify.com/api/',
  PATHS: {
    token: 'token',
    root: '',
  },
};

export const breakpoints = {
  sm: '540px',
  md: '728px',
  lg: '835px',
  xl: '1050px',
  '2xl': '1365px',
  '3xl': '1685px',
};

export type TBreakpointsKeys = keyof typeof breakpoints;

export const albumTypes = [
  { id: '', text: 'All' },
  { id: 'album', text: 'Albums' },
  { id: 'single', text: 'Singles and EPs' },
  { id: 'compilation', text: 'Compilations' },
];

export const header2ClassName = 'text-2xl font-bold mb-6';

export const spotifyWebPlaybackId = 'spotify_web_playback';
